// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__323KE","footer":"styles_footer__2vftt","passCodeTooltip":"styles_passCodeTooltip__218Rj"};